import ControlPointIcon from '@mui/icons-material/ControlPoint';
import {
  Box,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import SavLines from './SavLines.jsx';
const SavLinesForm = ({
  formData,
  handleFormChange,
  formError,
  handleCreateOrUpdateSavOrder,
}) => {
  const [line, setLine] = useState('');

  const handleChangeLine = (value) => {
    const trimmedValue = value.trim();
    setLine(trimmedValue);
  };

  const handleAddItem = async () => {
    let newLines = [
      { id: uuidv4(), internalProduct: line, reference: line, quantity: 1 },
      ...(formData?.lines || []),
    ];

    const res = formData.lines?.find((obj) => {
      return obj.internalProduct === line ? true : false;
    });
    const index = formData.lines?.indexOf(res);

    if (formData.lines[index] && formData.lines[index].quantity + 1 <= 10) {
      newLines = [
        {
          ...formData.lines[index],
          quantity: formData.lines[index].quantity + 1,
        },
        ...formData.lines.filter(
          (item) => item.id !== formData.lines[index].id
        ),
      ];
    }

    await handleCreateOrUpdateSavOrder(newLines);
    setLine('');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
      {formError?.lines?.length > 0 && (
        <FormHelperText error>{formError.lines}</FormHelperText>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
        <FormControl sx={{ width: '510px' }} variant="outlined">
          <OutlinedInput
            id="reference-piece"
            placeholder="Référence de la pièce ou du colis"
            type="text"
            size="small"
            onChange={(e) => handleChangeLine(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label={'ajouter une pièce ou un colis'}
                  onClick={handleAddItem}
                  edge="end"
                  disabled={line?.length !== 10}
                >
                  <ControlPointIcon />
                </IconButton>
              </InputAdornment>
            }
            value={line}
          />
          <Typography variant="caption" color="text.secondary">
            Exemple de références valides: COM-000001, PCS-004309, STI-000357,
            ACC-000143
          </Typography>
        </FormControl>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <SavLines
          lines={formData?.lines || []}
          handleFormChange={handleFormChange}
          formData={formData}
          formError={formError}
          handleCreateOrUpdateSavOrder={handleCreateOrUpdateSavOrder}
        />
      </Box>
    </Box>
  );
};

export default SavLinesForm;
